import { Center, Flex, Heading, Radio, Stack, Text } from "@chakra-ui/react"
import { Form, Formik } from "formik"
import { useDispatch, useSelector } from "react-redux"
import { ButtonBack, InputField, Layout, SelectField } from "../../../components"
import { RootState } from "../../app/mainReducer"
import { BotaoFinalizarEntrega, Images, ModalObservacoes, Temporizador } from "../components"
import { erroDoMotivoDevolucao, getMotivosNaoEntrega, montarGestoesDevolucaoTotal } from "../utils"
import { useState } from 'react'
import { entregaActions } from "../reducer"
import RadioField from "../../../components/RadioField"
import type { Carga } from "../../carga/types"
import { buscaCoordenadasParaEntrega } from "../../../utils/geolocalizacao"
import config from "../../../utils/config"
import useEntregaDaRota from "../../../hooks/useEntregaDaRota";
import useRedirecionaAposConcluirEntrega from "../../../hooks/useRedirecionaAposConcluirEntrega";

const RegistrarDevolucaoGrupo = () => {
  const gestao_entrega_temporario = useSelector((state: RootState) => state.entrega.gestao_entrega_temporario);
  const dispatch = useDispatch();
  const { j14_ukey, carga, entrega } = useEntregaDaRota();

  useRedirecionaAposConcluirEntrega(entrega, carga, j14_ukey);

  const [openModalObservacoes, setOpenModalObservacoes] = useState(false);
  const [openedModalObservacoes, setOpenedModalObservacoes] = useState(false);

  return (
    <Layout showFooter={true} isLoading={false} title={
      <>
        <ButtonBack />
        <Temporizador />
      </>
    }>
      <Center mt={8}>
        <Heading>Registrar Devolução</Heading>
      </Center>
      <Center mx={4} mb={6} mt={2} textAlign="center">
        <Text fontWeight="bold">
          {entrega?.fantasias}
          {entrega && <><br /><small>Devolução total de {entrega.notas.length === 1 ? '1 nota fiscal' : `${entrega.notas.length} notas fiscais`}: {entrega.notas_numeros.join(', ')}</small></>}
        </Text>
      </Center>

      <Flex px={4} width="full" direction="column">
        {entrega && gestao_entrega_temporario && <Formik
          enableReinitialize
          initialValues={gestao_entrega_temporario}
          onSubmit={async (val, { setErrors }) => {
            const erroMotivo = erroDoMotivoDevolucao(val, config.motivoDevolucaoTextoLivre);
            if (erroMotivo) {
              setErrors(config.motivoDevolucaoTextoLivre
                ? { motivo_devolucao_descricao: erroMotivo }
                : { motivo_devolucao: erroMotivo })
              return;
            }
            if (config.devolucaoExigirApenasFoto2) {
              if (!val.url_imagem2) {
                setErrors({ url_imagem2: "Tire a foto 2!" })
                return;
              }
            } else {
              if (!val.url_imagem1) {
                setErrors({ url_imagem1: "Tire a foto do canhoto!" })
                return;
              }
            }

            if (!openedModalObservacoes) {
              setOpenModalObservacoes(true);
              return;
            }

            const coordenadas = await buscaCoordenadasParaEntrega(val);

            if (!coordenadas) {
              dispatch(entregaActions.setError("Não foi possível obter a geolocalização. Verifique se o GPS está ativo, conceda permissão ao navegador e tente novamente ao ar livre."));
              return;
            }

            dispatch(entregaActions.registraNovoGestaoEntregaGrupo({
              gestoes: montarGestoesDevolucaoTotal(val, entrega.notas, coordenadas),
              carga: carga as Carga,
            }))
          }}
        >
          {({ values, handleSubmit, isSubmitting }) => (
            <Form>
              <InputField
                label="Nome do Recebedor"
                placeholder="Nome do Recebedor"
                name="nome_recebedor"
              />
              {config.motivoDevolucaoTextoLivre ? (
                <InputField
                  textarea
                  rows={3}
                  maxLength={200}
                  label="Motivo da Devolução"
                  placeholder="Descreva o motivo da devolução"
                  name="motivo_devolucao_descricao"
                />
              ) : (
                <SelectField
                  label="Motivo da Devolução"
                  name="motivo_devolucao"
                >
                  {getMotivosNaoEntrega().map(motivo => (
                    <option key={`${motivo.value}`} value={motivo.value}>{motivo.name}</option>
                  ))}
                </SelectField>
              )}

              {(config.motivoDevolucaoTextoLivre || values.motivo_devolucao == '4') && <RadioField mt={2} name="e_tentativa_entrega">
                <Stack mx="auto" direction="column" bg="white" p={4} borderRadius={5}>
                  <Radio size="lg" value={0}>Não vou reentregar, finalizar.</Radio>
                  <Radio size="lg" value={1}>Vou reentregar depois.</Radio>
                </Stack>
              </RadioField>}

              <Images large={true} recusaEntrega={config.devolucaoExigirApenasFoto2} />

              <ModalObservacoes onSubmited={handleSubmit} onOpenModal={openModalObservacoes} onOpenedModal={() => setOpenedModalObservacoes(true)} isLoading={isSubmitting} />

              <BotaoFinalizarEntrega isLoading={isSubmitting} />
            </Form>
          )}
        </Formik>}
      </Flex>
    </Layout>
  )
}

export default RegistrarDevolucaoGrupo;
